function validateName(caseConf) {
  const errors = [];
  if (!caseConf.name) {
    errors.push({ message: 'Scenario name is required', category: 'scenario', field: 'name' });
  }
  return {
    errors,
    warnings: [],
  };
}

export default validateName;
